import { render, staticRenderFns } from "./ClubAddUpdate.vue?vue&type=template&id=66fae840&"
import script from "./ClubAddUpdate.vue?vue&type=script&lang=js&"
export * from "./ClubAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ClubAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports